import React from "react";

const NoPage = () => {
	return (
		<div className="p-2 md:p-4 h-[calc(100vh-4rem)] overflow-scroll">
			NoPage
		</div>
	);
};

export default NoPage;
